import { Component, Input, ViewChild } from "@angular/core";
import { AuditLogService } from "configuration/services/audit-log.service";
import {
	AuditLogEntryListDto, IAuditLogEntryListDto, NetworkChangeListDto
} from "UvExplorerServer.Dtos.TS/AuditLogging";
import { DateService, MessageService } from 'base';
import { Paginator } from 'primeng/paginator';


export class AuditLogPagination {
	SortBy: string;
	Ascending: boolean;
	Skip: number = 0;
	Limit: number = 25;
	EventType: string = "";
	User: string = "";
	Description: string = "";
	DeviceName: string = "";
	IpAddress: string = "";
	MacAddress: string = "";
	IfIndex: string = "";
	IfName: string = "";
}

@Component({
	templateUrl: './audit-log-table.component.html',
	styleUrls: ['./audit-log-table.component.scss'],
	selector: 'audit-log-table',
	providers: [AuditLogPagination]
})
export class AuditLogTableComponent {

	@Input() public logType;

	@ViewChild(Paginator, { static: true }) paginator: Paginator

	public auditLog: IAuditLogEntryListDto;

	public get maxEntries() {
		return this.pagination.Limit;
	}

	public get isNetworkChangeLog() {
		return this.logType == "NetworkChangeEntry";
	}

	constructor(private pagination: AuditLogPagination, private auditLogService: AuditLogService,
		private dateService: DateService, private messageService: MessageService) {

	}

	private ngOnInit() {
		this.getAuditLogData();
		if (this.isNetworkChangeLog) {
			this.auditLog = new NetworkChangeListDto();
		}
		else {
			this.auditLog = new AuditLogEntryListDto();
		}
	}

	public filterUpdated(column: string, value: string): void {
		this.pagination[column] = value;
		this.updateEvents();
	}

	private getAuditLogData() {
		this.auditLogService.getAuditLog(this.pagination, this.logType).subscribe(
			(data: IAuditLogEntryListDto) => {
				if (!!data && !!data.entries) {
					data.entries.forEach((entry: any) => {
						let auditLogEntry = entry.audit_log_entry;

						if (!!auditLogEntry.audit_log_timestamp) {
							auditLogEntry.audit_log_timestamp = this.formatDateHm(auditLogEntry.audit_log_timestamp);
						}
						else {
							auditLogEntry.audit_log_timestamp = "";
						}
					});
				}

				this.auditLog = data;
			},
			(error) => {
				this.messageService.displayErrorMessage("Could not retrieve audit log messages");
			});
	}

	public paginate(event) {
		this.pagination.Skip = this.pagination.Limit * (event.page);
		this.getAuditLogData();
	}

	public updateEvents(): void {
		this.pagination.Skip = 0;
		this.paginator.changePage(0);
		this.getAuditLogData();
	}

	public formatDateHm(date: string | Date): string {
		let result: string = this.dateService.formatDateHm(date);
		return result;
	}

}
